module.exports = __webpack_public_path__ + "static/media/logo-dark.f26c89ab.svg";